<template>
  <div class="businessboard">
    <div class="businessboard--content">
      <div class="businessboard--header">
        <span class="h1">{{ budgetCalculation.name }}</span>
        <span
          v-if="isLoading"
          class="element--is-loading"></span>
      </div>
      <p>{{ $t('TotalBudget.info2') }}</p>
      <template v-if="storedFilter">
        <modal-filter
          @changeFilter="changeFilter"
          @saveFilter="saveFilter"
          :storedFilter="storedFilter"
          :companies="budgetFilterResultUnit.companies"
          :financialYears="budgetFilterResultUnit.financialYears" />
      </template>
      <template v-if="drillDown">
        <section class="businessboard--table">
          <drilldown-list :drillDownList="drillDown[0]"></drilldown-list>
        </section>
        <section class="businessboard--table">
          <drilldown-list :drillDownList="drillDown[1]"></drilldown-list>
        </section>
        <section class="businessboard--table">
          <drilldown-list :drillDownList="drillDown[2]"></drilldown-list>
        </section>
      </template>
      <section
        class="businessboard--table"
        v-if="budgetCalculation && budgetCalculation.incomes">
        <list-table
          :isLoading="isLoading"
          :items="budgetCalculation.incomes.rows"
          :headers="budgetCalculation.incomes.columns">
        </list-table>
      </section>
      <section
        class="businessboard--table"
        v-if="budgetCalculation && budgetCalculation.costs">
        <list-table
          :isLoading="isLoading"
          :items="budgetCalculation.costs.rows"
          :headers="budgetCalculation.costs.columns">
        </list-table>
      </section>
      <section
        class="businessboard--table"
        v-if="budgetCalculation && budgetCalculation.result">
        <list-table
          :isLoading="isLoading"
          :items="budgetCalculation.result.rows"
          :headers="budgetCalculation.result.columns">
        </list-table>
      </section>
    </div>
  </div>
</template>

<script>
import DrilldownList from '@/components/drilldown/drilldown-list.vue';
import ListTable from '@/components/list-table/list-table-game-calculation';
import ModalFilter from '@/components/modal/modal-filter-budget';
import LocalizationMixin from '@/mixins/localization-mixin';
export default {
  name: 'BusinessboardBudgetCalculationResultUnit',
  mixins: [LocalizationMixin],
  components: {
    ListTable,
    ModalFilter,
    DrilldownList,
  },
  props: {
    id: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      isLoading: true,
      storedFilter: false,
    };
  },
  computed: {
    drillDown() {
      return this.$store.getters['BusinessBoardDrilldown/budgetResultUnitUnit'];
    },
    budgetCalculation() {
      return this.$store.getters[
        'businessboardBudget/budgetCalculationResultUnit'
      ];
    },
    budgetFilterResultUnit() {
      return this.$store.getters['businessboardBudget/budgetFilterResultUnit'];
    },
    budgetFilterCompany() {
      return this.$store.getters['businessboardBudget/budgetFilterCompany'];
    },
  },
  mounted() {
    this.$store.dispatch('businessboardBudget/fetchBudgetFilterResultUnit', {
      id: this.id,
    });
    this.$store
      .dispatch('businessboardBudget/fetchBudgetResultunitFilter')
      .then(() => {
        this.storedFilter =
          this.$store.state.businessboardBudget.budgetResultunitFilter;
        this.fetch();
      });
  },
  watch: {
    $route: function () {
      this.fetch();
    },
  },
  methods: {
    changeFilter(filter) {
      this.storedFilter = filter;
      this.fetch();
    },
    saveFilter(filter) {
      this.storedFilter = filter;
      this.$store.dispatch('businessboardBudget/postBudgetResultunitFilter', {
        id: this.id,
        ...this.storedFilter,
      });
      this.fetch();
    },
    fetch() {
      this.isLoading = true;
      this.$store
        .dispatch('businessboardBudget/fetchBudgetCalculationResultUnit', {
          id: this.id,
          ...this.storedFilter,
        })
        .finally(() => {
          this.isLoading = false;
        });
      this.$store
        .dispatch('BusinessBoardDrilldown/fetchBudgetResultUnitUnit', {
          id: this.id,
          ...this.storedFilter,
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.businessboard--header {
  height: 3rem;
  margin: 1rem 0;
}
.h1 {
  display: inline-block;
  font-size: font(h1);
  font-weight: bold;
  vertical-align: top;
}
.element--is-loading {
  margin-left: 0.5rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50px' height='50px' viewBox='0 0 50 50'%3E%3Ccircle fill='none' stroke='%23517FD0' stroke-width='6' stroke-dasharray='45,40' cx='25' cy='25' r='15'/%3E%3CanimateTransform attributeName='transform' dur='1s' type='rotate' from='0 0 0 ' to='360 0 0' repeatCount='indefinite'/%3E%3C/svg%3E");
  background-size: 2rem 2rem;
  background-repeat: no-repeat;
  background-position: center center;
}
.businessboard {
  // margin: 1rem;
  flex-grow: 1;
  width: 100%;
  @include media('small') {
    width: calc((100% / 2) - (1rem * 1));
  }
  @include media('large') {
    width: calc((100% / 3) - (1rem * 2));
  }
}
.businessboard--content {
  background-color: color(white);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
}
.businessboard--table {
  margin-bottom: 2rem;
}
</style>
